// ./src/components/features/Memberships/MembershipTypesMultiSelect/MembershipTypesMultiSelect.tsx
//
// Several of the account's membership types — "which memberships this accepts" (a members-only ticket type, a
// members-only RSVP). None chosen = any membership. The single-type `MembershipTypeSelect` (price rules) did not fit:
// this one answers a SET, so it is the generic CheckableMultiSelect (full screen on a phone) fed the same whole list.
// ⓘ Wrapped in an Input.Wrapper so the field carries a description and the SERVER's refusal at the field.

import React, { useEffect, useMemo, useState } from "react";
import { Input } from "@mantine/core";
import { OP_RESULT_CODES } from "@sdflc/api-helpers";

import { CheckableMultiSelect } from "@/components/generic/CheckableMultiSelect/CheckableMultiSelect";
import { MembershipType, MembershipTypeService, listAllPages } from "@/utils/api";

export interface MembershipTypesMultiSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  label?: React.ReactNode;
  description?: React.ReactNode;
  disabled?: boolean;
  /** Server-side refusal for this field — without it a listed error is swallowed. */
  error?: string | null;
}

export const MembershipTypesMultiSelect: React.FC<MembershipTypesMultiSelectProps> = ({ value, onChange, label, description, disabled, error }) => {
  const [types, setTypes] = useState<MembershipType[]>([]);

  // The account's whole list (a picker's options are a whole set). Plain cancellation, as MembershipTypeSelect.
  useEffect(() => {
    let alive = true;

    listAllPages(MembershipTypeService.list, {}).then((result) => {
      if (alive && result.code === OP_RESULT_CODES.OK && Array.isArray(result.data)) {
        setTypes(result.data as MembershipType[]);
      }
    });

    return () => {
      alive = false;
    };
  }, []);

  const data = useMemo(() => types.filter((mt) => mt.id).map((mt) => ({ value: mt.id as string, label: mt.name || "—" })), [types]);

  return (
    <Input.Wrapper label={label} description={description} error={error ?? undefined} size="md">
      <CheckableMultiSelect data={data} value={value} onChange={onChange} placeholder="Any membership" disabled={disabled} />
    </Input.Wrapper>
  );
};
